module.exports = __webpack_public_path__ + "static/media/my-percentage-coming-soon-banner.5617108b.jpg";